import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { Tenant } from '../models/tenant';
import { TENANT_KEY } from '../services/tenant-key.provider';

@Injectable()
export class TenantKeyGuard implements CanActivate {
  private router = inject(Router);
  private tenantKey = inject(TENANT_KEY);

  public canActivate(): boolean | UrlTree {
    return Tenant.isValidKey(this.tenantKey) || this.router.parseUrl('error/invalid-tenant-key');
  }

}
